import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { MyPractitionerLayout } from '@/features/practitioners/components/shared/MyPractitionerLayout';
import { PractitionerEditScreen } from '@/features/practitioners/components/workspace/PractitionerEditScreen';

export const Route = createFileRoute('/app/profile/edit')({
  component: ClinicalMyProfileEditScreen,
  staticData: { crumb: 'Edit' },
});

function ClinicalMyProfileEditScreen() {
  const navigate = useNavigate();
  return (
    <MyPractitionerLayout>
      {(practitionerId) => (
        <PractitionerEditScreen
          practitionerId={practitionerId}
          backTo={{ to: '/app/profile', label: 'My profile' }}
          onCompleted={() => {
            void navigate({ to: '/app/profile' });
          }}
        />
      )}
    </MyPractitionerLayout>
  );
}
